// @ts-nocheck -- legacy receiving contracts are migrated incrementally below.
import React, { useEffect, useRef, useState } from "react";

import { useForm } from "../../useForm";
import { useNavigate } from "react-router-dom";

import Input from "../../../controls/Input";
import SelectMenu from "../../../controls/SelectMenu";
import TextArea from "../../../controls/TextArea";

import { format } from "date-fns";

import {
  classNames,
  conditionTypes,
  convertToDefEventPara,
  ingestBarcodeScan,
  isEmployeeUserType,
  yesOrNoOptions,
} from "../../../../shared/utility";
import {
  fetchLocationsForDropdown,
  fetchLocationZonesForDropdown,
  normalizeDropdownOption,
} from "../../../../shared/locationDropdowns";
import { readDefaultLocationFromStorage } from "../../../../shared/defaultLocationStorage";
import AssemblyItemsTableComponent from "../../../../viewmodels/receiving/invoices/AssemblyItemsTableComponent";
import DatePickerInput from "../../../controls/DatePickerInput";

import ConfirmPricePopup from "./ConfirmPricePopup";
import ReceivingBarcodeLabel from "./ReceivingBarcodeLabel";
import InvoiceItemsTable from "./InvoiceItemsTable";

const initialFValues = {
  invoice_number: "",
  date: "",
  assembly_item_id: "",
  is_barcode: { value: 2, label: "Barcode" },
  received_by: { value: -1, label: "" },
  manufacturer_id: "",
  supplier: { value: null, label: "" },
  product_name: "",
  lot_number: "",
  unit: "",
  received_amount: "",
  unit_cost: "",
  total_cost: "",
  pallet_condition: { value: 1, label: "Satisfactory" },
  product_condition: { value: 1, label: "Satisfactory" },
  product_quality: { value: 1, label: "Satisfactory" },
  purchase_order: { value: null, label: "" },
  cfia_meat: { value: 0, label: "N/A" },
  lab_results: { value: 0, label: "N/A" },
  is_halal: { value: 0, label: "N/A" },
  barcode: "",
  box_date: "",
  note: "",
  notes: "",
  certification_type: 0,
  allergens: "",
  preservatives: "",
  product_type: 0,
  product_claims: 0,
  truck_temperature: "",
  truck_condition: { value: 1, label: "Satisfactory" },
  location: null,
  zone: null,
  number_of_cartons: 1,
};

const barcodeOptions = [
  { value: 1, label: "No Barcode" },
  { value: 2, label: "Barcode" },
];

const fieldClassName =
  "mt-1 block w-full rounded-xl border border-[#E2E8F0] bg-white px-3 py-2.5 text-sm text-[#0F172A] shadow-sm transition placeholder:text-[#64748B]/70 focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10 disabled:bg-[#F6F8FB] disabled:text-[#64748B]";

const sectionClassName =
  "rounded-[18px] border border-[#E2E8F0] bg-white p-4 shadow-[0_1px_2px_rgba(15,23,42,0.04)]";

const primaryButtonClass =
  "inline-flex items-center justify-center rounded-xl border border-[#2563EB] bg-[#2563EB] px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:border-[#1D4ED8] hover:bg-[#1D4ED8] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2563EB]";

const tealButtonClass =
  "inline-flex items-center justify-center rounded-xl border border-[#0D9488] bg-[#0D9488] px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:border-[#0F766E] hover:bg-[#0F766E] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0D9488]";

const neutralButtonClass =
  "inline-flex items-center justify-center rounded-xl border border-[#E2E8F0] bg-white px-4 py-2 text-sm font-semibold text-[#0F172A] shadow-sm transition hover:border-[#94A3B8] hover:bg-[#F6F8FB] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#64748B]";

const warningButtonClass =
  "inline-flex items-center justify-center rounded-xl border border-[#F59E0B] bg-[#F59E0B] px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:border-[#D97706] hover:bg-[#D97706] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#F59E0B]";

const dangerButtonClass =
  "inline-flex items-center justify-center rounded-xl border border-[#DC2626] bg-[#DC2626] px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:border-[#B91C1C] hover:bg-[#B91C1C] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#DC2626]";

function withRequiredLabel(label) {
  return (
    <>
      {label}
      <span className="text-[#DC2626]"> *</span>
    </>
  );
}

function supplierFromPurchaseOrderOption(purchaseOrderOption, suppliers = []) {
  const supplier = purchaseOrderOption?.supplier;
  if (!supplier?.id) {
    return { value: null, label: "" };
  }
  const match = suppliers.find((option) => option.value === supplier.id);
  return match ?? { value: supplier.id, label: supplier.name };
}

function findPurchaseOrderOption(purchaseOrderValue, purchaseOrderOptions) {
  if (!purchaseOrderValue?.value) {
    return null;
  }
  return (
    purchaseOrderOptions.find(
      (option) => option.value === purchaseOrderValue.value,
    ) ?? purchaseOrderValue
  );
}

function ButtonSpinner() {
  return (
    <svg
      className="h-5 w-5 animate-spin text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

export default function AddReceivingInvoiceForm(props) {
  const {
    addItemToReceivingInvoice,
    barcodeDetails,
    linkedPurchaseOrder,
    purchaseOrderId,
    createReceivingInvoice,
    getAllAssemblyItems,
    getAssemblyItemByPlu,
    invoice,
    invoiceItems,
    setInvoiceItems,
    onGenerateBarcodePdf,
    isEdit,
    setSlideOver,
    updateReceivingInvoiceApiCall,
    showErrorModal,
    openReceivingItemDetails,
    deleteReceivingItem,
    deleteMultipleReceivingItems,
    setEmptyModelOpen,
    employeeOptions,
    suppliers,
    printReceivingReportByID,
    getInvoiceProducts,
    purchaseOrderOptions,
  } = props;

  const [barcodeScanInProgress, setBarcodeScanInProgress] = useState(false);
  const [createBarcodeInProgress, setCreateBarcodeInProgress] = useState(false);
  const [createInvoiceInProgress, setCreateInvoiceInProgress] = useState(false);
  const [updateInvoiceInProgress, setUpdateInvoiceInProgress] = useState(false);
  const [currentBarcodeItemPlu, setCurrentBarcodeItemPlu] = useState(null);
  const [lastAddedItemPayload, setLastAddedItemPayload] = useState(null);
  const [shouldShowBarcode, setShouldShowBarcode] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);
  const [zoneOptions, setZoneOptions] = useState([]);

  const [isEmployee, setIsEmployee] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsEmployee(isEmployeeUserType());
  }, []);

  useEffect(() => {
    const loadLocations = async () => {
      const callResult = await fetchLocationsForDropdown();
      if (callResult.success) {
        setLocationOptions(callResult.data || []);
      }
    };
    loadLocations();
  }, []);

  const validate = (fieldValues) => {
    let temp = { ...errors };
    temp.supplier = null;
    if (values.supplier.value < 1) {
      temp.supplier = "Please fill out field.";
    }

    // if ("is_barcode" in fieldValues) {
    //   temp.is_barcode = null;
    //   if (fieldValues.is_barcode.value < 1) {
    //     temp.is_barcode = "Please fill out field.";
    //   }
    // }

    if ("invoice_number" in fieldValues) {
      temp.invoice_number = null;
      if (fieldValues.invoice_number === "") {
        temp.invoice_number = "Please fill out field.";
      }
    }

    if ("received_by" in fieldValues || fieldValues.received_by === 0) {
      temp.received_by = null;
      if (fieldValues.received_by.value < 1) {
        temp.received_by = "Please fill out field.";
      }
    }

    if ("truck_temperature" in fieldValues) {
      temp.truck_temperature = null;
      if (fieldValues.truck_temperature === "") {
        temp.truck_temperature = "Please fill out field.";
      }
    }

    if ("truck_condition" in fieldValues) {
      temp.truck_condition = null;
      if (
        fieldValues.truck_condition === "" ||
        fieldValues.truck_condition === 0
      ) {
        temp.truck_condition = "Please fill out field.";
      }
    }

    temp.purchase_order = null;
    const purchaseOrder = fieldValues.purchase_order ?? values.purchase_order;
    if (!purchaseOrder?.value || purchaseOrder.value < 1) {
      temp.purchase_order = "Please fill out field.";
    }

    // if ("received_amount" in fieldValues) {
    //   temp.received_amount = null;
    //   if (fieldValues.received_amount === "" && values.is_barcode.value === 1) {
    //     temp.received_amount = "Please fill out field.";
    //   }
    // }

    // if ("unit_cost" in fieldValues) {
    //   temp.unit_cost = null;
    //   if (fieldValues.unit_cost === "") {
    //     temp.unit_cost = "Please set a price.";
    //   }
    // }

    // if ("lot_number" in fieldValues) {
    //   temp.lot_number = null;
    //   if (fieldValues.lot_number === "") {
    //     temp.lot_number = "Please fill out field.";
    //     const ib = fieldValues.is_barcode ?? values.is_barcode;
    //     if (ib?.value === 2) {
    //       showErrorModal("Please choose a supplier item.");
    //     }
    //   }
    // }

    // if ("pallet_condition" in fieldValues) {
    //   temp.pallet_condition = null;
    //   if (
    //     fieldValues.pallet_condition === "" ||
    //     fieldValues.pallet_condition === 0
    //   ) {
    //     temp.pallet_condition = "Please fill out field.";
    //   }
    // }

    // if ("product_condition" in fieldValues) {
    //   temp.product_condition = null;
    //   const pc = fieldValues.product_condition;
    //   const pv =
    //     typeof pc === "object" && pc !== null && "value" in pc
    //       ? pc.value
    //       : pc;
    //   if (
    //     pv === "" ||
    //     pv === 0 ||
    //     pv === undefined ||
    //     pv === null
    //   ) {
    //     temp.product_condition = "Please fill out field.";
    //   }
    // }

    // if ("product_quality" in fieldValues) {
    //   temp.product_quality = null;
    //   const pq = fieldValues.product_quality;
    //   const qv =
    //     typeof pq === "object" && pq !== null && "value" in pq
    //       ? pq.value
    //       : pq;
    //   if (
    //     qv === "" ||
    //     qv === 0 ||
    //     qv === undefined ||
    //     qv === null
    //   ) {
    //     temp.product_quality = "Please fill out field.";
    //   }
    // }

    // if ("number_of_cartons" in fieldValues) {
    //   temp.number_of_cartons = null;
    //   const rawNc =
    //     fieldValues.number_of_cartons !== undefined
    //       ? fieldValues.number_of_cartons
    //       : values.number_of_cartons;
    //   const n = Number(rawNc);
    //   const barcodeMode =
    //     (fieldValues.is_barcode ?? values.is_barcode)?.value === 2;
    //   if (!Number.isFinite(n) || n < 1) {
    //     temp.number_of_cartons = "Enter at least 1 carton.";
    //   } else if (barcodeMode && n > 1) {
    //     temp.number_of_cartons = "Barcode mode allows at most 1 carton.";
    //   } else if (!barcodeMode && n > 500) {
    //     temp.number_of_cartons =
    //       "At most 500 cartons when generating barcodes.";
    //   }
    // }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === null);
  };

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false,
    validate,
  );

  useEffect(() => {
    const loadZones = async () => {
      if (!values.location?.value) {
        setZoneOptions([]);
        return;
      }
      const callResult = await fetchLocationZonesForDropdown(values.location);
      if (callResult.success) {
        setZoneOptions(callResult.data || []);
      }
    };
    loadZones();
  }, [values.location?.value]);

  const barcodeInputRef = useRef(null);

  // Normalize invoice data from API format to form format
  const normalizeInvoiceData = (invoiceData) => {
    if (!invoiceData) return invoiceData;

    const normalized = { ...invoiceData };

    // Helper function to normalize condition fields
    const normalizeCondition = (
      value,
      defaultValue = { value: 1, label: "Satisfactory" },
    ) => {
      if (typeof value === "object" && value !== null && "value" in value) {
        return value;
      } else if (typeof value === "number" || typeof value === "string") {
        const conditionValue =
          typeof value === "string" ? parseInt(value) : value;
        const foundCondition = conditionTypes.find(
          (c) => c.value === conditionValue,
        );
        return foundCondition || defaultValue;
      }
      return defaultValue;
    };

    // Normalize condition fields
    normalized.pallet_condition = normalizeCondition(
      invoiceData.pallet_condition,
    );
    normalized.truck_condition = normalizeCondition(
      invoiceData.truck_condition,
    );
    normalized.product_condition = normalizeCondition(
      invoiceData.product_condition,
    );
    normalized.product_quality = normalizeCondition(
      invoiceData.product_quality,
    );

    // Ensure is_barcode is in object format
    if (
      invoiceData.is_barcode === undefined ||
      typeof invoiceData.is_barcode !== "object" ||
      invoiceData.is_barcode === null ||
      !("value" in invoiceData.is_barcode)
    ) {
      normalized.is_barcode = { value: 2, label: "Barcode" };
    }

    normalized.location = normalizeDropdownOption(invoiceData.location);
    normalized.zone = normalizeDropdownOption(invoiceData.zone);
    normalized.notes = invoiceData.notes ?? "";

    return normalized;
  };

  useEffect(() => {
    if (isEdit && invoice) {
      const normalizedInvoice = normalizeInvoiceData(invoice);
      const firstItem = invoiceItems?.[0]?.sub_items?.[0];

      setValues({
        ...normalizedInvoice,
        invoice_id: invoice.id,
        is_barcode: { value: 2, label: "Barcode" },
        purchase_order: {
          value: invoice?.purchase_order?.id,
          label: invoice?.purchase_order?.po_number,
        },
        truck_temperature:
          firstItem?.truck_temperature ??
          normalizedInvoice.truck_temperature ??
          "",
        notes: normalizedInvoice.notes ?? "",
      });
    } else {
      const linkedPoSupplier = linkedPurchaseOrder?.supplier;
      setValues({
        ...values,
        purchase_order: {
          value: linkedPurchaseOrder?.id,
          label: linkedPurchaseOrder?.po_number,
        },
        supplier: linkedPoSupplier?.id
          ? supplierFromPurchaseOrderOption(
              { supplier: linkedPoSupplier },
              suppliers,
            )
          : values.supplier,
        location:
          normalizeDropdownOption(linkedPurchaseOrder?.location) ??
          readDefaultLocationFromStorage(),
        date: format(new Date(), "LLL dd, YYY"),
      });
    }
  }, [
    isEdit,
    invoice,
    invoiceItems,
    suppliers,
    employeeOptions,
    linkedPurchaseOrder,
  ]);

  useEffect(() => {
    if (!values.purchase_order?.value || !purchaseOrderOptions.length) {
      return;
    }

    const fullOption = findPurchaseOrderOption(
      values.purchase_order,
      purchaseOrderOptions,
    );
    const supplier = supplierFromPurchaseOrderOption(fullOption, suppliers);
    if (!supplier.value || values.supplier?.value === supplier.value) {
      return;
    }

    setValues((prev) => ({ ...prev, supplier }));
  }, [values.purchase_order?.value, purchaseOrderOptions, suppliers]);

  useEffect(() => {
    setShouldShowBarcode(
      values.is_barcode?.value === 2 &&
        values.invoice_number !== "" &&
        typeof values.supplier === "object" &&
        values.supplier?.value > 0 &&
        values.received_by?.value > 0 &&
        values.pallet_condition?.value > 0 &&
        values.truck_condition?.value > 0 &&
        values.truck_temperature !== "" &&
        values.purchase_order?.value > 0,
    );
  }, [values]);

  const openSearchAssemblyItems = async function () {
    var supplierId = values.supplier?.value;

    let callResult = await getAllAssemblyItems(supplierId);
    if (callResult.success) {
      setSlideOver({
        childComponent: (
          <AssemblyItemsTableComponent
            assemblyItemsList={callResult.data.assembly_items}
            setItemValues={(assemblyItem) => {
              // if (assemblyItem.supplier_id == values.supplier.value) {
              setValues({
                ...values,
                barcode: "",
                assembly_item_id: assemblyItem.id,
                manufacturer_id: assemblyItem.manufacturer_id,
                manufacturer_name: assemblyItem.manufacturer_name,
                received_amount: assemblyItem.received_amount,
                product_name: assemblyItem.product_name,
                plu: assemblyItem.manufacturer_plu,
                unit_cost: assemblyItem.cost,
                lot_number: "",
                certification_type: assemblyItem.certification_type,
                product_type: assemblyItem.product_type,
                total_cost: values.received_amount * assemblyItem.cost,
                unit_of_measure: assemblyItem.unit_of_measure_text,
                ingredient_id: assemblyItem.ingredient_id,
              });
              // } else {
              //   showErrorModal("Suppliers do not match");
              // }
            }}
            setOpen={setSlideOver}
          />
        ),
        open: true,
      });
    } else {
    }
  };

  const continueAddingItemToInvoice = (newValues) => {
    if (invoice.id > 0) {
      addItemToInvoice(newValues);
    } else {
      onCreateInvoice(newValues);
    }
    setLastAddedItemPayload(newValues);
  };

  const handleBarcodeScan = async function (scannedBarcode) {
    if (scannedBarcode || scannedBarcode !== "") {
      setBarcodeScanInProgress(true);

      const barcodeInfo = ingestBarcodeScan(scannedBarcode);

      const barcodePlu = barcodeInfo.plu;
      if (currentBarcodeItemPlu !== barcodePlu) {
        setCurrentBarcodeItemPlu(barcodePlu);
      }

      if (barcodePlu || barcodePlu !== "") {
        let callResult = await getAssemblyItemByPlu(barcodePlu);

        if (callResult) {
          const newValues = {
            ...values,
            plu: barcodePlu,
            barcode: scannedBarcode,
            box_date: barcodeInfo.date,
            received_amount: barcodeInfo.weight,
            certification_type: callResult.certification_type["value"],
            manufacturer_id: callResult.manufacturer["value"],
            manufacturer_name: callResult.manufacturer["label"],
            unit_cost: callResult.cost,
            lot_number: values.lot_number,
            product_name: callResult.product_name,
            assembly_item_id: callResult.id,
            product_type: callResult.product_type["value"],
            total_cost: callResult.cost * barcodeInfo.weight,
            unit_of_measure: callResult.unit_of_measure,
            ingredient_id: callResult.ingredient_id,
          };

          // We show the cost popup then don't show it again unless plu changes
          if (currentBarcodeItemPlu === barcodePlu) {
            setEmptyModelOpen({
              childComponent: (
                <ConfirmPricePopup
                  assemblyItem={callResult}
                  newValues={newValues}
                  setNewCostForItem={continueAddingItemToInvoice}
                  setOpen={setEmptyModelOpen}
                  previousItem={lastAddedItemPayload}
                />
              ),
              open: true,
            });
          } else {
            setValues(newValues);
            setEmptyModelOpen({
              childComponent: (
                <ConfirmPricePopup
                  assemblyItem={callResult}
                  newValues={newValues}
                  setNewCostForItem={continueAddingItemToInvoice}
                  setOpen={setEmptyModelOpen}
                  previousItem={lastAddedItemPayload}
                />
              ),
              open: true,
            });
          }
        }
      }
      setBarcodeScanInProgress(false);
    }
  };

  const checkAssemblyItemChosen = (newValues) => {
    if (newValues.assembly_item_id < 1) {
      showErrorModal("Please choose a supplier item.");
      return false;
    } else {
      return true;
    }
  };

  const clearAssemblyItemValues = (newValues) => {
    const nextIsBarcode = newValues.is_barcode ?? values.is_barcode;
    const isBarcodeMode = nextIsBarcode?.value === 2;
    setValues({
      ...values,
      ...newValues,
      ...(newValues.is_barcode !== undefined
        ? { number_of_cartons: isBarcodeMode ? 1 : values.number_of_cartons }
        : {}),
      receiving_item_id: "",
      allergens: "",
      barcode: "",
      barcode_url: "",
      box_date: "",
      certification_type: "",
      manufacturer_id: "",
      manufacturer_name: "",
      received_amount: "",
      preservatives: "",
      product_claims: "",
      unit_cost: "",
      assembly_item_id: "",
      lot_number: "",
      plu: "",
      product_name: "",
      product_type: "",
      total_cost: "",
    });
  };

  const handlePurchaseOrderChange = (e) => {
    const purchaseOrder = e.target.value;
    const fullOption = findPurchaseOrderOption(
      purchaseOrder,
      purchaseOrderOptions,
    );
    const supplier = supplierFromPurchaseOrderOption(fullOption, suppliers);

    clearAssemblyItemValues({
      purchase_order: purchaseOrder,
      supplier,
      is_barcode: values.is_barcode,
      lot_number: "",
    });
  };

  const addItemToInvoice = async function (newValues) {
    var newValuesCopy = { ...newValues };
    if (!(Number(newValues.invoice_id) > 0)) {
      newValuesCopy = { ...newValuesCopy, invoice_id: invoice.id };
    }

    if (newValuesCopy.zone?.value && !values.location?.value) {
      showErrorModal(
        "Receiving invoice location is required when a zone is selected.",
      );
      return;
    }

    const validateResult = validate(newValuesCopy);
    if (validateResult && checkAssemblyItemChosen(newValuesCopy)) {
      var callResult = await addItemToReceivingInvoice(newValuesCopy);

      if (callResult.success) {
        if (barcodeInputRef.current) {
          barcodeInputRef.current.focus();
        }
      } else {
        setValues({ ...values, scanned_box_label: "" });
        if (barcodeInputRef.current) {
          barcodeInputRef.current.focus();
        }
      }
    } else {
      if (!validateResult) {
        showErrorModal("Please make sure you filled out all fields.");
      } else if (values.assembly_item_id < 1) {
        console.log("oggy error -2");
        showErrorModal("Please select a supplier item.");
      } else {
        showErrorModal("Please make sure you filled out all fields.");
      }
    }
  };

  const onCreateInvoice = async function (newValues) {
    if (validate(newValues)) {
      setCreateInvoiceInProgress(true);
      var callResult = await createReceivingInvoice(newValues);

      if (callResult.success) {
        const newInvoiceId = callResult.data.receiving_invoice.id;
        // setValues({
        //   ...values,
        //   invoice_id: newInvoiceId,
        // });
        // addItemToInvoice({
        //   ...newValues,
        //   invoice_id: newInvoiceId,
        // });

        navigate(`/receiving-invoices/${newInvoiceId}`);
      }

      setCreateInvoiceInProgress(false);
    } else {
      showErrorModal("Please make sure you filled out all fields.");
    }
  };

  const updateReceivingInvoice = async function () {
    if (!validate(values)) {
      showErrorModal("Please make sure you filled out all fields.");
      return;
    }

    setUpdateInvoiceInProgress(true);
    var callResult = await updateReceivingInvoiceApiCall(values, invoice.id);

    setUpdateInvoiceInProgress(false);
  };

  const generateBarcodeStringClicked = async function () {
    setCreateBarcodeInProgress(true);
    const callResult = await onGenerateBarcodePdf({
      receiving_item_id: values.receiving_item_id,
    });
    setCreateBarcodeInProgress(false);

    if (callResult.success) {
      setTimeout(() => {
        window.print();
      }, 1500);
    }
  };

  const handleTotalUnitKeyDown = (event) => {
    if (event.key === "Enter") {
      handleInputChange(
        convertToDefEventPara("received_amount", eval(values.received_amount)),
      );
    }
  };

  return (
    <div className="justify-between">
      <div className="hide-for-print space-y-5">
        <section className="rounded-[18px] border border-[#E2E8F0] bg-white px-5 py-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)] sm:px-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#64748B]">
                QA Trace / Receiving
              </p>
              <h3 className="mt-1 text-2xl font-semibold tracking-tight text-[#0F172A]">
                {isEdit
                  ? "Editing invoice: " + invoice.invoice_number
                  : "Add new receiving invoice"}
              </h3>
              <p className="mt-2 max-w-2xl text-sm leading-6 text-[#64748B]">
                Capture inbound materials, supplier details, quality checks, and
                lot-level receiving information.
              </p>
            </div>
            <div className="flex flex-shrink-0 flex-wrap items-center gap-2">
              {isEdit ? (
                <button
                  type="button"
                  onClick={() => updateReceivingInvoice()}
                  disabled={createInvoiceInProgress}
                  className={primaryButtonClass}
                >
                  {createInvoiceInProgress ? <ButtonSpinner /> : "Save"}
                </button>
              ) : null}
              {invoice.id > 0 ? null : (
                <button
                  type="button"
                  onClick={() => onCreateInvoice(values)}
                  disabled={createInvoiceInProgress}
                  className={primaryButtonClass}
                >
                  {createInvoiceInProgress ? (
                    <ButtonSpinner />
                  ) : (
                    "Create receiving"
                  )}
                </button>
              )}
              {invoice.id > 0 ? (
                <button
                  type="button"
                  onClick={() => printReceivingReportByID()}
                  className={neutralButtonClass}
                >
                  Print invoice
                </button>
              ) : null}
            </div>
          </div>
        </section>

        {linkedPurchaseOrder && purchaseOrderId ? (
          <section className="rounded-[18px] border border-[#2563EB]/30 bg-[#EFF6FF] px-5 py-4 shadow-sm sm:px-6">
            <p className="text-sm font-semibold text-[#0F172A]">
              Receiving against purchase order{" "}
              {linkedPurchaseOrder.po_number ?? `#${purchaseOrderId}`}
            </p>
            <p className="mt-1 text-sm text-[#64748B]">
              Supplier and PO# are prefilled from the PO. The receiving invoice
              created will be linked to the PO.
            </p>
            {(linkedPurchaseOrder.items || linkedPurchaseOrder.line_items || [])
              .length > 0 ? (
              <ul className="mt-3 list-inside list-disc text-sm text-[#475569]">
                {(
                  linkedPurchaseOrder.items ||
                  linkedPurchaseOrder.line_items ||
                  []
                )
                  .slice(0, 8)
                  .map((line) => (
                    <li
                      key={
                        line.id ??
                        line.purchase_order_item_id ??
                        line.assembly_item_id
                      }
                    >
                      {line.description ??
                        line.product_name ??
                        line.item_name ??
                        "Item"}{" "}
                      — ordered {line.ordered_amount ?? line.ordered_quantity}{" "}
                      {line.unit_of_measure?.label ??
                        (typeof line.unit_of_measure === "string"
                          ? line.unit_of_measure
                          : "")}
                    </li>
                  ))}
              </ul>
            ) : null}
          </section>
        ) : null}

        <div className="space-y-5">
          {/* Invoice Info Section - Full Width */}
          <div className={sectionClassName}>
            <p className="mb-4 text-xs text-[#64748B]">
              Fields marked with{" "}
              <span className="font-medium text-[#DC2626]">*</span> are
              required.
            </p>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              <SelectMenu
                handleInputChange={handlePurchaseOrderChange}
                name="purchase_order"
                value={values.purchase_order}
                options={purchaseOrderOptions}
                title={withRequiredLabel("Purchase Order")}
                error={errors.purchase_order}
                filter
              />
              <Input
                label={withRequiredLabel("Invoice #")}
                name="invoice_number"
                onChange={handleInputChange}
                value={values.invoice_number}
                labelOn={true}
                type="text"
                className={fieldClassName}
                error={errors.invoice_number}
              />
              <div>
                <DatePickerInput
                  label="Date"
                  name="date"
                  onChange={handleInputChange}
                  value={values.date}
                  labelOn={true}
                  type="text"
                  dateFormat={"LLL dd, YYY"}
                  className={fieldClassName}
                />
              </div>
              <div>
                <SelectMenu
                  handleInputChange={handleInputChange}
                  name="supplier"
                  options={suppliers}
                  value={values.supplier}
                  title={withRequiredLabel("Supplier")}
                  error={errors.supplier}
                  disabled={true}
                  placeholder={
                    values.purchase_order?.value
                      ? "Set by purchase order"
                      : "Select a purchase order first"
                  }
                />
              </div>
            </div>
            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              <div>
                <SelectMenu
                  handleInputChange={handleInputChange}
                  name="received_by"
                  options={employeeOptions}
                  defaultValue={isEdit ? invoice.received_by : null}
                  title={withRequiredLabel("Received by")}
                  error={errors.received_by}
                  value={values.received_by}
                />
              </div>
              <div>
                <SelectMenu
                  handleInputChange={(e) => {
                    handleInputChange(e);
                    setValues((prev) => ({
                      ...prev,
                      location: e.target.value,
                      zone: null,
                    }));
                  }}
                  name="location"
                  options={locationOptions}
                  value={values.location}
                  title="Location"
                  placeholder="Select location…"
                />
              </div>
              <div>
                <Input
                  label={withRequiredLabel("Truck Temperature")}
                  name="truck_temperature"
                  onChange={handleInputChange}
                  value={values.truck_temperature}
                  labelOn={true}
                  type="text"
                  className={fieldClassName}
                  error={errors.truck_temperature}
                />
              </div>
              <div>
                <SelectMenu
                  handleInputChange={handleInputChange}
                  name="truck_condition"
                  options={conditionTypes}
                  value={values.truck_condition}
                  title={withRequiredLabel("Truck Condition")}
                  error={errors.truck_condition}
                />
              </div>
              <div>
                <SelectMenu
                  handleInputChange={handleInputChange}
                  name="pallet_condition"
                  value={values.pallet_condition}
                  options={conditionTypes}
                  title={withRequiredLabel("Pallet Condition")}
                  error={errors.pallet_condition}
                />
              </div>
              <SelectMenu
                handleInputChange={(e) => {
                  clearAssemblyItemValues({
                    is_barcode: e.target.value,
                    lot_number: values.lot_number,
                  });
                }}
                name="is_barcode"
                value={values.is_barcode}
                options={barcodeOptions}
                title={"Is barcode"}
                disabled={invoice.id < 1}
                error={errors.is_barcode}
              />
              <div className="col-span-2">
                <TextArea
                  label="Notes"
                  labelOn
                  name="notes"
                  rows={3}
                  parentClass="w-full"
                  className={fieldClassName}
                  placeholder=""
                  value={values.notes ?? ""}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          {/* Product Info Section - only after invoice exists; hidden when Barcode mode */}
          {invoice.id > 0 ? (
            <div
              className={classNames(
                values.is_barcode.value === 2 ? "hidden" : sectionClassName,
              )}
            >
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:items-end">
                <div>
                  <label className="block text-sm font-medium text-[#334155] mb-1"></label>
                  <button
                    className={`${tealButtonClass} w-full`}
                    onClick={() => {
                      openSearchAssemblyItems();
                    }}
                  >
                    Search supplier items
                  </button>
                </div>
                <div>
                  <Input
                    label="Product name"
                    name="product_name"
                    onChange={handleInputChange}
                    value={values.product_name}
                    labelOn={true}
                    type="text"
                    disabled={true}
                    className={fieldClassName}
                  />
                </div>
                <div>
                  <Input
                    label="Lot Number"
                    name="lot_number"
                    onChange={handleInputChange}
                    value={values.lot_number}
                    labelOn={true}
                    type="text"
                    className={fieldClassName}
                    error={errors.lot_number}
                  />
                </div>
                <div>
                  <Input
                    label="Received amount (per carton)"
                    name="received_amount"
                    onChange={handleInputChange}
                    value={values.received_amount}
                    labelOn={true}
                    type="text"
                    className={fieldClassName}
                    error={errors.received_amount}
                  />
                </div>

                <div>
                  <Input
                    label="Number of cartons"
                    name="number_of_cartons"
                    onChange={handleInputChange}
                    value={values.number_of_cartons}
                    labelOn={true}
                    type="number"
                    min={1}
                    max={values.is_barcode.value === 2 ? 1 : 500}
                    className={fieldClassName}
                    error={errors.number_of_cartons}
                  />
                </div>
                <div>
                  <Input
                    label="Unit of measure"
                    name="unit_of_measure"
                    onChange={handleInputChange}
                    value={values.unit_of_measure}
                    labelOn={true}
                    type="text"
                    className={fieldClassName}
                    error={errors.unit_of_measure}
                    disabled={true}
                  />
                </div>
                <div>
                  <SelectMenu
                    handleInputChange={handleInputChange}
                    name="zone"
                    options={zoneOptions}
                    value={values.zone}
                    title="Zone"
                    isClearable
                    placeholder={
                      values.location?.value
                        ? "Select zone…"
                        : "Set invoice location first"
                    }
                    disabled={!values.location?.value}
                  />
                </div>
                <div>
                  <Input
                    label="Unit cost"
                    name="unit_cost"
                    onChange={handleInputChange}
                    value={values.unit_cost}
                    labelOn={true}
                    type="number"
                    className={fieldClassName}
                    error={errors.unit_cost}
                  />
                </div>
                <div>
                  <SelectMenu
                    handleInputChange={handleInputChange}
                    name="product_condition"
                    options={conditionTypes}
                    value={values.product_condition}
                    title="Product Condition"
                    error={errors.product_condition}
                  />
                </div>
                <div>
                  <SelectMenu
                    handleInputChange={handleInputChange}
                    name="product_quality"
                    options={conditionTypes}
                    value={values.product_quality}
                    title="Product Quality"
                    error={errors.product_quality}
                  />
                </div>
                <div>
                  <SelectMenu
                    handleInputChange={handleInputChange}
                    name="cfia_meat"
                    options={yesOrNoOptions}
                    value={values.cfia_meat}
                    title="CFIA Meat"
                  />
                </div>
                <div>
                  <SelectMenu
                    handleInputChange={handleInputChange}
                    name="lab_results"
                    options={yesOrNoOptions}
                    value={values.lab_results}
                    title="Lab Results"
                  />
                </div>
                <div>
                  <SelectMenu
                    handleInputChange={handleInputChange}
                    name="is_halal"
                    options={yesOrNoOptions}
                    value={values.is_halal}
                    title="Is Halal"
                  />
                </div>
                {values.is_barcode.value === 1 &&
                Number(values.number_of_cartons) > 1 ? (
                  <p className="col-span-2 sm:col-span-4 text-xs text-[#64748B]">
                    Total received amount is split evenly across cartons when
                    generating barcodes.
                  </p>
                ) : null}
                {values.is_barcode.value === 1 &&
                values.receiving_item_id > 0 ? (
                  <div className="col-span-full flex justify-end border-t border-[#E2E8F0] pt-4">
                    <button
                      type="button"
                      onClick={() => generateBarcodeStringClicked(values)}
                      disabled={createBarcodeInProgress}
                      className={neutralButtonClass}
                    >
                      {createBarcodeInProgress ? (
                        <ButtonSpinner />
                      ) : (
                        "Print barcode"
                      )}
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}

          {shouldShowBarcode && invoice.id > 0 ? (
            <div className={sectionClassName}>
              <label
                htmlFor="scanned_box_label"
                className="mb-1 block text-sm font-medium text-[#334155]"
              >
                Scan box label
              </label>
              <input
                id="scanned_box_label"
                placeholder="Scan or type box label and press Enter"
                name="scanned_box_label"
                disabled={barcodeScanInProgress}
                ref={barcodeInputRef}
                onChange={handleInputChange}
                value={values.scanned_box_label}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleBarcodeScan(e.target.value);
                }}
                type="text"
                className={fieldClassName}
              />
            </div>
          ) : null}

          {/* Invoice Items Table - Three Level Expandable */}
          <InvoiceItemsTable
            invoiceItems={invoiceItems}
            invoiceId={invoice?.id}
            isEmployee={isEmployee}
            openReceivingItemDetails={openReceivingItemDetails}
            deleteReceivingItem={deleteReceivingItem}
            deleteMultipleReceivingItems={deleteMultipleReceivingItems}
            setInvoiceItems={setInvoiceItems}
            setEmptyModelOpen={setEmptyModelOpen}
            setSlideOver={setSlideOver}
            showErrorModal={showErrorModal}
            onAddItem={() => addItemToInvoice(values)}
            addItemInProgress={createInvoiceInProgress}
            showAddItem={invoice.id > 0 && values.is_barcode.value !== 2}
            invoiceLocation={values.location}
            zoneOptions={zoneOptions}
          />
        </div>
      </div>
      <ReceivingBarcodeLabel barcodeDetails={barcodeDetails} />
    </div>
  );
}
